import React from 'react';

import './QuestionButton.scss';

interface Props {
    children: React.ReactNode;
    disabled: boolean;
    onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
    forward: boolean;
}

export default class QuestionButton extends React.Component<Props> {
    public render() {
        const buttonClass = [
            'button',
            'button--secondary',
            this.props.forward ? 'button--icon-right' : 'button--icon-left',
            'button--question',
        ];

        const icon = (
            <svg className="icon icon--arrow">
                <use xlinkHref="#icon-arrow" />
            </svg>
        );

        return (
            <button
                type="button"
                onClick={this.props.onClick}
                disabled={this.props.disabled}
                className={buttonClass.join(' ')}
            >
                {this.props.forward === false ? <>{icon}</> : ''}
                {this.props.children}

                {this.props.forward === true ? <>{icon}</> : ''}
            </button>
        );
    }
}
